
export function FeaturesOverviewSection() {
  const features = [
    {
      icon: 'ri-brain-line',
      title: 'AI Threat Detection',
      description: 'UK-trained machine learning models analyze emails and SMS messages in real-time, identifying phishing and smishing attempts with 99.7% accuracy.',
      benefits: ['Real-time scanning', 'UK-specific datasets', 'Malicious URL detection', 'Social engineering analysis']
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Employee Training Nudges',
      description: 'Transform risky moments into learning opportunities with contextual security training delivered exactly when employees need it most.',
      benefits: ['Micro-learning approach', 'Real-time alerts', 'Behavioral improvement', 'No formal training needed']
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Unified SME Dashboard',
      description: 'Get complete visibility into your security posture with actionable insights, threat summaries, and employee risk assessments.',
      benefits: ['Live threat monitoring', 'Employee risk scores', 'Actionable insights', 'Simple reporting']
    },
    {
      icon: 'ri-cloud-line',
      title: 'Remote Management',
      description: 'Deploy and manage protection across all company devices without needing an internal IT department or complex infrastructure.',
      benefits: ['5-minute deployment', 'Cross-platform support', 'Automatic updates', 'No IT team required']
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Complete Cybersecurity in One Platform
            </h2>
            <p className="text-xl text-gray-400">
              Everything your UK business needs to stay protected from phishing and smishing attacks
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {features.map((feature, index) => (
              <div key={index} className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
                <div className="w-12 h-12 bg-blue-500/200/20 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-blue-400 text-xl`}></i>
                </div>
                <h3 className="text-2xl font-semibold text-white mb-4">
                  {feature.title}
                </h3>
                <p className="text-gray-400 mb-6 leading-relaxed">
                  {feature.description}
                </p>
                <div className="space-y-2">
                  {feature.benefits.map((benefit, benefitIndex) => (
                    <div key={benefitIndex} className="flex items-center">
                      <div className="w-4 h-4 bg-blue-500/200/20 rounded-full flex items-center justify-center mr-3">
                        <i className="ri-check-line text-blue-400 text-xs"></i>
                      </div>
                      <span className="text-gray-300 text-sm">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
